// src/auth/Gate.jsx
import { useAuth } from "./AuthContext";
import { can } from "../config/roles";

export default function Gate({ perm, children, fallback = null }) {
  const { user } = useAuth();
  if (!perm) return children;
  return can(user, perm) ? children : fallback;
}
